/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_8_PInputs */

const en_terms_8_p = /** @type {(inputs: Terms_8_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can stop using Bystep and delete your account at any time. We may terminate or suspend access for breach of these terms, with notice where practical.`)
};

const id_terms_8_p = /** @type {(inputs: Terms_8_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu bisa berhenti memakai Bystep dan menghapus akun kapan saja. Kami dapat menghentikan atau menangguhkan akses karena pelanggaran ketentuan ini, dengan pemberitahuan bila memungkinkan.`)
};

/**
* | output |
* | --- |
* | "You can stop using Bystep and delete your account at any time. We may terminate or suspend access for breach of these terms, with notice where practical." |
*
* @param {Terms_8_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_8_p = /** @type {((inputs?: Terms_8_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_8_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_8_p(inputs)
	return en_terms_8_p(inputs)
});